var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M11.999 21.682c-.327 0-.654-.059-.965-.175C6.376 19.76 3.25 15.249 3.25 10.279V7.443c0-1.131.709-2.163 1.765-2.567l6-2.301a2.75 2.75 0 0 1 1.969 0l6 2.301a2.766 2.766 0 0 1 1.765 2.567v2.836c0 4.97-3.126 9.481-7.78 11.227a2.76 2.76 0 0 1-.971.177zM12 3.892c-.152 0-.304.028-.448.083l-6 2.301c-.48.184-.802.653-.802 1.167v2.836c0 4.348 2.735 8.295 6.807 9.822.289.108.6.108.882.001 4.076-1.529 6.812-5.476 6.812-9.824V7.442c0-.514-.322-.983-.802-1.167l-6-2.301a1.256 1.256 0 0 0-.448-.083z",
    opacity: 1,
    "data-original": "#112d55",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M11.4 14.75a.753.753 0 0 1-.558-.248l-2.4-2.667a.751.751 0 0 1 1.116-1.004l1.842 2.047 3.042-3.381a.75.75 0 0 1 1.116 1.004l-3.6 4a.752.752 0 0 1-.558.248z",
    opacity: 1,
    "data-original": "#549bff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.b4015f3786ac23cdc29bd7fa7afecdc0.svg";
export { ForwardRef as ReactComponent };